export function t(i18nKey, options) {
  if (window.I18n !== undefined) {
    return window.I18n.t(i18nKey, options);
  }

  return i18nKey;
}

export function l(i18nKey, options) {
  if (window.I18n !== undefined) {
    return window.I18n.l(i18nKey, options);
  }

  return i18nKey;
}

const RI18n = {
  t,
  l,
};

export default RI18n;
